const styles = () => ({
  root: {
    display: 'flex',
  },
  appContainer: {
    marginTop: 64,
  },
});

export default styles;
